import React from 'react';
import { Inbox } from 'lucide-react';

function EmptyState({ icon: Icon = Inbox, title = 'Nothing here yet', description, action }) {
  return (
    <div className="state">
      <div className="state-icon"><Icon size={24} /></div>
      <h3>{title}</h3>
      {description && <div>{description}</div>}
      {action}
    </div>
  );
}

export default EmptyState;
